import { AxiosError } from 'axios'

export function buildAxiosErrorContext(axiosError: AxiosError) {
  const responseData = axiosError.response?.data ?? {}

  try {
    return {
      requestData: JSON.parse(axiosError.config?.data),
      responseData
    }
  } catch (error) {
    return {
      requestData: axiosError.config?.data ?? {},
      responseData
    }
  }
}
